import { Box, Button, Header } from '@rbilabs/universal-components';

import Dialog from 'components/dialog';
import Picture from 'components/picture';

export const StyledHeader = Header.withConfig({
  fontSize: '2xl',
  fontWeight: Styles.fontWeight.heavy,
  accessibilityLevel: 1,
  variant: 'headerOne',
  alignSelf: 'flex-start',
  fontFamily: Styles.fontFamily.body,
});

export const StyledBody = Box.withConfig({
  marginTop: '$0',
  marginBottom: '$6',
  _text: {
    fontSize: 'md',
  },
  _android: {
    marginBottom: '$4',
  },
});

export const StyledDialog = Dialog.withConfig({
  paddingTop: '$4',
  textAlign: 'left',
});

export const StyledPicture = Picture.withConfig({
  maxWidth: '85%',
  alignSelf: 'center',
});

export const StyledTextOnlyButton = Button.withConfig({
  variant: 'ghost',
  paddingX: '$12',
  paddingY: '$3',
  marginTop: '$1',
  _text: {
    textTransform: 'capitalize',
  },
});

export const StyledButton = Button.withConfig({
  _text: {
    textTransform: 'capitalize',
  },
});

export const StyledOutlineButton = Button.withConfig({
  variant: 'outline',
});
